import _ from 'lodash';
import {
    FETCH_JOKL_COUPONS,
    CLEAN_JOKL_COUPONS,
    SET_JOKL_COUPON_PROCESSED,
    DELETE_JOKL_COUPON,
} from './types';
import { request, __ } from '../functions';

export const fetchJoklCoupons = (screen, options = {}, id) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request(`/jokl/coupons/${id}`, params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_JOKL_COUPONS, payload: data });
    });
};

export const setJoklCouponProcessed = (screen, code, number) => {
    return dispatch => request(`/jokl/setProcessedCoupon/${code}`, { number }, 'POST').then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Nepodarilo sa zmeniť stav kupónu'));
            return;
        }

        screen.showSnackbar('success', __('Stav kupónu bol zmenený'));

        dispatch({ type: SET_JOKL_COUPON_PROCESSED, payload: { code, number } });
    });
};

export const deleteJoklCoupon = (screen, id) => {
    return dispatch => request(`/jokl/removeCoupon/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Kupón sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Kupón bol zmazaný'));

        dispatch({ type: DELETE_JOKL_COUPON });
    });
};

export const cleanJoklCoupons = () => ({ type: CLEAN_JOKL_COUPONS });
